import React from 'react';
export function SiteFooter() {
  return <footer className="border-t border-white/10 bg-navy-900" data-id="element-137" data-mp="1dr1f9lwgpvek">
      <div className="mx-auto flex max-w-content flex-col gap-6 px-4 py-12 sm:px-6" style={{
      paddingTop: "8px",
      paddingBottom: "8px",
      marginTop: "0px",
      marginBottom: "0px"
    }} data-id="element-138" data-mp="3r7zltgib8e8m">
        <p className="font-display text-sm font-bold uppercase tracking-[0.18em] text-white" data-id="element-139" data-mp="3hj7y5kka8g3i">
          দ্য আর্জেন্টাইন মাইন্ডসেট © ২০২৬ <span className="text-white/40" data-id="element-140" data-mp="3difoiq7i096p">|</span> সর্বস্বত্ব
          সংরক্ষিত
        </p>
        <p className="max-w-3xl text-xs leading-relaxed text-white/45" data-id="element-141" data-mp="38gymgrda2goj">
          <span className="font-semibold text-white/60" data-id="element-142" data-mp="33hvjrdkrsmjq">দাবিত্যাগ:</span> ফলাফল ব্যক্তি অনুযায়ী
          ভিন্ন হয়। এটি শিক্ষামূলক কনটেন্ট। দ্য আর্জেন্টাইন মাইন্ডসেট আয় বা সাফল্যের কোনো
          গ্যারান্টি নয়, বরং মানসিকতা ও সিদ্ধান্ত নেওয়ার ক্ষমতা উন্নত করার একটি সিস্টেম।
          আপনার ফলাফল আপনার পরিশ্রমের উপর নির্ভর করে।
        </p>
        <nav aria-label="ফুটার" className="flex flex-wrap items-center gap-x-6 gap-y-2 border-t border-white/10 pt-6 text-sm text-white/60" style={{
        paddingTop: "0px",
        paddingBottom: "0px",
        paddingLeft: "8px",
        paddingRight: "8px",
        alignItems: "flex-start",
        justifyContent: "center"
      }} data-id="element-143" data-mp="wt0dpkb113q8">
          <a href="mailto:soporte@kodadigital.shop" className="transition-colors duration-200 ease-smooth hover:text-celeste-300" data-id="element-144" data-mp="10riqetlbc2jh">
            soporte@kodadigital.shop
          </a>
          <a href="#" className="transition-colors duration-200 ease-smooth hover:text-celeste-300" data-id="element-145" data-mp="1tgg4ekihrd6f">
            প্রাইভেসি পলিসি
          </a>
          <a href="#" className="transition-colors duration-200 ease-smooth hover:text-celeste-300" data-id="element-146" data-mp="1eqidvxx3abe2">
            টার্মস অব সার্ভিস
          </a>
        </nav>
      </div>
    </footer>;
}